import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { TextKeys } from '../../core/i18n/text-keys';
import { ToastService } from 'src/app/core/services/toast-service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-barcode-scan-modal',
  templateUrl: './barcode-scan-modal.component.html',
  styleUrls: ['./barcode-scan-modal.component.scss'],
})
export class BarcodeScanModalComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Output() barcodeReceived = new EventEmitter<string>();
  @ViewChild('barcodeInputElement')
  barcodeInputElement!: ElementRef<HTMLInputElement>;

  texts = TextKeys;
  barcodeInput = '';

  readonly SCAN_IDLE_MS = 60;
  readonly MIN_LEN = 6;
  readonly MAX_LEN = 64;

  private focusInterval: any;
  private commitTimer: any;

  constructor(
    private toastService: ToastService,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.focusInput();
    this.focusInterval = setInterval(() => this.focusInput(true), 1000);
  }

  ngOnDestroy() {
    clearInterval(this.focusInterval);
    clearTimeout(this.commitTimer);
  }

  private focusInput(silent = false) {
    const el = this.barcodeInputElement?.nativeElement;
    if (!el) return;
    if (document.activeElement !== el) {
      try {
        el.focus();
      } catch {}
    }
    if (!silent)
      try {
        el.select();
      } catch {}
  }

  onInput(evt: Event) {
    const el = evt.target as HTMLInputElement;

    let val = (el.value || '').replace(/[\r\n]+/g, '');
    if (val.length > this.MAX_LEN) val = val.slice(0, this.MAX_LEN);

    this.barcodeInput = val;

    clearTimeout(this.commitTimer);
    this.commitTimer = setTimeout(() => {
      // only commit if min length reached
      if (this.barcodeInput && this.barcodeInput.length >= this.MIN_LEN) {
        this.commit(this.barcodeInput);
      }
    }, this.SCAN_IDLE_MS);
  }

  onEnter() {
    const code = (this.barcodeInput || '').trim();
    if (code.length >= this.MIN_LEN) {
      clearTimeout(this.commitTimer);
      this.commit(code);
    }
  }

  private async commit(code: string) {
    try {
      this.barcodeReceived.emit(code);
    } finally {
      this.barcodeInput = '';
      const el = this.barcodeInputElement?.nativeElement;
      if (el) el.value = '';

      await this.dismiss();
    }
  }

  async dismiss() {
    try {
      await this.modalCtrl.dismiss();
    } catch {
      /* no-op wenn kein ModalController */
    }
  }

  close() {
    this.dismiss();
  }
}
